import styles from "./SimpleLoader.module.css";


function SimpleLoader({ }) {

    return (
        <span className={styles.simpleLoader}>
            <span></span>
            <span></span>
            <span></span>
        </span>
    );
}

export default SimpleLoader;